// =============================================
// SERVICIO DE CARGA MASIVA
// Maneja upload de Excel
// =============================================

import api from './api';

const bulkUploadService = {
  // BULK: Subir Excel de pagos
  uploadPayments: async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/bulk/payments', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // BULK: Subir Excel de gastos
  uploadExpenses: async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/bulk/expenses', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // BULK: Descargar plantilla de pagos
  downloadPaymentsTemplate: async () => {
    const response = await api.get('/bulk/template/payments', {
      responseType: 'blob',
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'plantilla-pagos.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
  },

  // BULK: Descargar plantilla de gastos
  downloadExpensesTemplate: async () => {
    const response = await api.get('/bulk/template/expenses', {
      responseType: 'blob',
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'plantilla-gastos.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
};

export default bulkUploadService;
